import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function requestOtp(token, params) {
    return Api.post(REQUEST_URLS.COMPANY_APPROVAL.REQUEST_OTP, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default requestOtp;